<script>
import ChatAca from "./components/ChatAca.vue";
export default {
    components: {
        ChatAca,
    },
    data() {
        return {
            ActiveTab: "",
            showPlugin: false,
        };
    },
    computed: {
        ag() {
            return this.$parent.ag;
        },
        wid() {
            return this.$parent.wid;
        },
        Setting() {
            return this.$parent.Settings;
        },
        Translation() {
            return this.$parent.Translation;
        },
    },
    mounted() {
        if (window.innerWidth > 991) {
            this.showPlugin = false;
        }
    },
};
</script>
<template>
    <div>
        <button type="button" class="btn conexus-trigger" @click="showPlugin = !showPlugin">
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="64" height="64" viewBox="0 0 64 64">
                <path
                    d="M32,6C17.641,6,6,17.641,6,32s11.641,26,26,26s26-11.641,26-26S46.359,6,32,6z M14,44l1-5.5l3-0.5l1,6H14z M15,36v-4.5	l3,1.5v3H15z M44,41c-0.676,2.704-5.592,4.974-11,5s-10.324-2.296-11-5l-2-7l13,5l13-6L44,41z M33,36l-19-8l-1-2l19-5l20,4l-1,2	L33,36z"
                    fill="#ffffff"
                ></path>
            </svg>
        </button>

        <div class="conexus" :class="{show: showPlugin}">
            <div class="conexus-head" role="button" @click="showPlugin = !showPlugin">
                <div class="conexus-icon"></div>
                <div class="conexus-text">
                    <h5 class="title">Search your Universities</h5>
                    <p class="desc">Find your dream university and get accepted with the help of our expert counsellors.</p>
                </div>
            </div>
            <button type="button" class="btn btn-close" @click="showPlugin = !showPlugin"></button>
            <div class="conexus-content">
                <ChatAca />
                <p class="fs-7 mb-0 lh-sm fw-500 mt-2 text-center">In partnership with</p>
                <a href="https://uniapplynow.com" target="_blank" rel="noopener noreferrer" role="button">
                    <img src="https://studentpanel.net/widget/icons/uniapplynow-light.png" alt="*" class="img-fluid mx-auto d-block" width="190" />
                </a>
            </div>
        </div>
    </div>
</template>
